import { CALL_API, Schemas } from '../../common/middleware/api';

export const KINDERGARTEN_ATTENDANCE_REQUEST = 'KINDERGARTEN_ATTENDANCE_REQUEST';
export const KINDERGARTEN_ATTENDANCE_SUCCESS = 'KINDERGARTEN_ATTENDANCE_SUCCESS';
export const KINDERGARTEN_ATTENDANCE_FAILURE = 'KINDERGARTEN_ATTENDANCE_FAILURE';

export const KINDERGARTEN_PAYMENTS_UNPAGED_REQUEST = 'KINDERGARTEN_PAYMENTS_UNPAGED_REQUEST';
export const KINDERGARTEN_PAYMENTS_UNPAGED_SUCCESS = 'KINDERGARTEN_PAYMENTS_UNPAGED_SUCCESS';
export const KINDERGARTEN_PAYMENTS_UNPAGED_FAILURE = 'KINDERGARTEN_PAYMENTS_UNPAGED_FAILURE';

export const KINDERGARTEN_PAYMENT_UPDATE_REQUEST = 'KINDERGARTEN_PAYMENT_UPDATE_REQUEST';
export const KINDERGARTEN_PAYMENT_UPDATE_SUCCESS = 'KINDERGARTEN_PAYMENT_UPDATE_SUCCESS';
export const KINDERGARTEN_PAYMENT_UPDATE_FAILURE = 'KINDERGARTEN_PAYMENT_UPDATE_FAILURE';

export const KINDERGARTEN_PAYMENT_DETAIL_UPDATE_REQUEST = 'KINDERGARTEN_PAYMENT_DETAIL_UPDATE_REQUEST';
export const KINDERGARTEN_PAYMENT_DETAIL_UPDATE_SUCCESS = 'KINDERGARTEN_PAYMENT_DETAIL_UPDATE_SUCCESS';
export const KINDERGARTEN_PAYMENT_DETAIL_UPDATE_FAILURE = 'KINDERGARTEN_PAYMENT_DETAIL_UPDATE_FAILURE';

export const KINDERGARTEN_PAYMENT_DETAIL_CREATE_REQUEST = 'KINDERGARTEN_PAYMENT_DETAIL_CREATE_REQUEST';
export const KINDERGARTEN_PAYMENT_DETAIL_CREATE_SUCCESS = 'KINDERGARTEN_PAYMENT_DETAIL_CREATE_SUCCESS';
export const KINDERGARTEN_PAYMENT_DETAIL_CREATE_FAILURE = 'KINDERGARTEN_PAYMENT_DETAIL_CREATE_FAILURE';

export const KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST = 'KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST';
export const KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS = 'KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS';
export const KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE = 'KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE';

export const loadKindergartenAttendances = (options) => ({
	[CALL_API]: {
		types: [KINDERGARTEN_ATTENDANCE_REQUEST, KINDERGARTEN_ATTENDANCE_SUCCESS, KINDERGARTEN_ATTENDANCE_FAILURE],
		endpoint: 'api/kindergartenPaymentDetails/attendances',
		request: options,
		schema: Schemas.KINDERGARTEN_ATTENDANCES
	}
});

export const loadKindergartenPayments = (options) => ({
	[CALL_API]: {
		types: [KINDERGARTEN_PAYMENTS_UNPAGED_REQUEST, KINDERGARTEN_PAYMENTS_UNPAGED_SUCCESS, KINDERGARTEN_PAYMENTS_UNPAGED_FAILURE],
		endpoint: 'api/kindergartenPayment/unpaged',
		request: options,
		schema: Schemas.KINDERGARTEN_PAYMENT_ARRAY
	}
});

export const updateKindergartenPayment = (id, kindergartenPayment, onSuccessEvent) => ({
	[CALL_API]: {
		types: [KINDERGARTEN_PAYMENT_UPDATE_REQUEST, KINDERGARTEN_PAYMENT_UPDATE_SUCCESS, KINDERGARTEN_PAYMENT_UPDATE_FAILURE],
		endpoint: `api/kindergartenPayment/${id}`,
		method: 'PUT',
		request: kindergartenPayment,
		schema: Schemas.KINDERGARTEN_PAYMENT,
		form: 'kindergartenPaymentForm',
		onSuccessEvent
	}
});

export const createKindergartenPaymentDetail = (kindergartenPaymentDetail, onSuccessEvent) => ({
	[CALL_API]: {
		types: [KINDERGARTEN_PAYMENT_DETAIL_UPDATE_REQUEST, KINDERGARTEN_PAYMENT_DETAIL_UPDATE_SUCCESS, KINDERGARTEN_PAYMENT_DETAIL_UPDATE_FAILURE],
		endpoint: 'api/kindergartenPaymentDetails',
		method: 'POST',
		request: kindergartenPaymentDetail,
		schema: Schemas.KINDERGARTEN_PAYMENT_DETAIL,
		form: 'kindergartenPaymentDetailForm',
		onSuccessEvent
	}
});

export const updateKindergartenPaymentDetail = (id, kindergartenPaymentDetail, onSuccessEvent) => ({
	[CALL_API]: {
		types: [KINDERGARTEN_PAYMENT_DETAIL_CREATE_REQUEST, KINDERGARTEN_PAYMENT_DETAIL_CREATE_SUCCESS, KINDERGARTEN_PAYMENT_DETAIL_CREATE_FAILURE],
		endpoint: `api/kindergartenPaymentDetails/${id}`,
		method: 'PUT',
		request: kindergartenPaymentDetail,
		schema: Schemas.KINDERGARTEN_PAYMENT_DETAIL,
		form: 'kindergartenPaymentDetailForm',
		onSuccessEvent
	}
});

export const loadWeeklyProgram = (options) => ({
	[CALL_API]: {
		types: [
			KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST,
			KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS,
			KINDERGARTEN_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE
		],
		endpoint: 'api/weeklyPrograms/unpaged',
		request: options,
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});